import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { AddNewEmbedRPC } from "./addNewEmbedRPC";

export class AddNewEmbedRPCClientImpl extends AddNewEmbedRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: AddNewEmbedRPC.Request): Promise<LeoRPCResult<AddNewEmbedRPC.Response, AddNewEmbedRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "report/AddNewEmbed",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      AddNewEmbedRPC.ResponseDTO,
      AddNewEmbedRPC.Errors.ErrorsDTO,
      AddNewEmbedRPC.Response,
      AddNewEmbedRPC.Errors.Errors
    >(
      response,
      "report/AddNewEmbed",
      AddNewEmbedRPC.Response.fromDTO,
      AddNewEmbedRPC.Errors.fromDTO
    );
  }
}
